/**
 *功能: 权限路由相关
 */

import menuList from '@/mock/customerServiceMenu.json';
import generaMenu from '@/utils/generaMenu';
import $souter from '@/router';

const Layout = () => import('@/views/layout');

const State = {
  routerList: [],
};

const Getters = {
  routerList: state => state.routerList,
};

const Mutations = {
  INIT_ROUTERS(state, commData) {
    state.routerList = commData;
  },
};

// actions
const Actions = {
  // 初始化动态路由
  initRouters({ commit }, routers = '') {
    return new Promise(resolve => {
      setTimeout(() => {
        // const router = generaMenu([], routers ? routers.bean : menuList);
        const router = generaMenu([], menuList);
        $souter.addRoutes([
          {
            path: '/',
            name: 'layout',
            component: Layout,
            children: router,
          },
        ]);
        $souter.onReady(() => {
          setTimeout(() => {
              resolve(true);
            },
            2000);
        });
        console.warn('routersConfig', router);
        commit('INIT_ROUTERS', routers);
      }, 1000);
    });
  },
};

export default {
  namespaced: true,
  strict: true,
  state: State,
  getters: Getters,
  actions: Actions,
  mutations: Mutations,
};
